export const toCalendarSubscriptionUrl = (url: string): string => {
  const raw = String(url || "").trim();
  if (!raw || raw.startsWith("webcal:")) return raw;

  try {
    const parsed = new URL(
      raw,
      typeof window !== "undefined" ? window.location.origin : undefined,
    );
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.href.replace(/^https?:/, "webcal:");
    }
  } catch {
    return raw;
  }

  return raw;
};
